import React, { useState } from 'react'
// import { Tabs, Tab } from 'react-bootstrap'
import { connect } from 'react-redux'
import Tab1 from './Tab1'
// import Tab2 from './Tab2'
import dotnetify, { useConnect } from 'dotnetify'

dotnetify.hubServerUrl = "http://coreapi.bitick.ir";

const AdminDashboard = (props) => {
  // const [activeTab, setActiveTab] = useState("dashboard")

  // const { state } = useConnect("HelloWorld", { Greetings: "" });


  const { user } = props;
  return (
    <React.Fragment>
      {/* <Tabs transition={false}
       className="dashboard-tabs"
       activeKey={activeTab}
       onSelect={key => setActiveTab(key)}
     > */}

      {/* <Tab eventKey="dashboard" title="داشبورد"> */}
      {user && user.userType !== undefined && [0].includes(user.userType) &&
        <Tab1 />
      }
      {/* </Tab> */}


      {/* </Tabs> */}
    </React.Fragment>
  )
}

// export default AdminDashboard;

function mapStateToProps(state) {
  const { authentication } = state;
  const { user } = authentication;
  return {
    user
  };
}

const connectedAdminDashboard = connect(mapStateToProps)(AdminDashboard);
export { connectedAdminDashboard as AdminDashboard };